"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationTypesTable = NotificationTypesTable;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const types_1 = require("@src/types");
const elements_1 = require("@src/components/elements");
const icons_1 = require("@ant-design/icons");
const app_context_1 = require("@src/context/app-context");
function NotificationTypesTable({ notificationTypesSettings, isLoading, onCheckboxChange }) {
    const intl = (0, react_intl_1.useIntl)();
    const appContext = (0, app_context_1.useAppContextValue)();
    const rows = react_1.default.useMemo(() => {
        if (!notificationTypesSettings) {
            return [];
        }
        const typeSettingRows = [];
        if (types_1.NotificationType.COMPANY_SUBSCRIPTION_NOTIFICATION in notificationTypesSettings) {
            typeSettingRows.push({
                typeId: types_1.NotificationType.COMPANY_SUBSCRIPTION_NOTIFICATION,
                name: intl.formatMessage({ id: 'global.notification.new_company_offer.type' }),
                description: intl.formatMessage({ id: 'global.notification.new_company_offer.description' }),
                ...notificationTypesSettings[types_1.NotificationType.COMPANY_SUBSCRIPTION_NOTIFICATION],
            });
        }
        if (types_1.NotificationType.OFFER_SUBSCRIPTION_NOTIFICATION in notificationTypesSettings) {
            typeSettingRows.push({
                typeId: types_1.NotificationType.OFFER_SUBSCRIPTION_NOTIFICATION,
                name: intl.formatMessage({ id: 'global.notification.new_subscription_offer.type' }),
                description: intl.formatMessage({ id: 'global.notification.new_subscription_offer.description' }),
                ...notificationTypesSettings[types_1.NotificationType.OFFER_SUBSCRIPTION_NOTIFICATION],
            });
        }
        if (types_1.NotificationType.NEW_COMPANY_SUBSCRIBER_NOTIFICATION in notificationTypesSettings) {
            typeSettingRows.push({
                typeId: types_1.NotificationType.NEW_COMPANY_SUBSCRIBER_NOTIFICATION,
                name: intl.formatMessage({ id: 'global.notification.new_company_subscriber.type' }),
                description: intl.formatMessage({ id: 'global.notification.new_company_subscriber.description' }),
                ...notificationTypesSettings[types_1.NotificationType.NEW_COMPANY_SUBSCRIBER_NOTIFICATION],
            });
        }
        if (types_1.NotificationType.HIRING_PROCESS_RESULT_NOTIFICATION in notificationTypesSettings) {
            typeSettingRows.push({
                typeId: types_1.NotificationType.HIRING_PROCESS_RESULT_NOTIFICATION,
                name: intl.formatMessage({ id: 'global.notification.hiring_process_result.title' }),
                description: intl.formatMessage({ id: 'global.notification.hiring_process_result.description' }),
                ...notificationTypesSettings[types_1.NotificationType.HIRING_PROCESS_RESULT_NOTIFICATION],
            });
        }
        if (types_1.NotificationType.HIRING_PROCESS_CLOSED_NOTIFICATION in notificationTypesSettings) {
            typeSettingRows.push({
                typeId: types_1.NotificationType.HIRING_PROCESS_CLOSED_NOTIFICATION,
                name: intl.formatMessage({ id: 'global.notification.hiring_process_result.title' }),
                description: intl.formatMessage({ id: 'global.notification.hiring_process_closed.description' }),
                ...notificationTypesSettings[types_1.NotificationType.HIRING_PROCESS_CLOSED_NOTIFICATION],
            });
        }
        if (types_1.NotificationType.NEW_OFFER_APPLICATION_NOTIFICATION in notificationTypesSettings) {
            typeSettingRows.push({
                typeId: types_1.NotificationType.NEW_OFFER_APPLICATION_NOTIFICATION,
                name: intl.formatMessage({ id: 'global.notification.new_offer_application.type' }),
                description: intl.formatMessage({ id: 'global.notification.new_offer_application.description' }),
                ...notificationTypesSettings[types_1.NotificationType.NEW_OFFER_APPLICATION_NOTIFICATION],
            });
        }
        if (types_1.NotificationType.CREDITS_EXPIRATION_NOTIFICATION in notificationTypesSettings) {
            typeSettingRows.push({
                typeId: types_1.NotificationType.CREDITS_EXPIRATION_NOTIFICATION,
                name: intl.formatMessage({ id: 'global.notification.credits_expiration.type' }),
                description: intl.formatMessage({ id: 'global.notification.credits_expiration.description' }),
                ...notificationTypesSettings[types_1.NotificationType.CREDITS_EXPIRATION_NOTIFICATION],
            });
        }
        if (types_1.NotificationType.COMPANY_VIEWED_RESUME_NOTIFICATION in notificationTypesSettings) {
            typeSettingRows.push({
                typeId: types_1.NotificationType.COMPANY_VIEWED_RESUME_NOTIFICATION,
                name: intl.formatMessage({ id: 'global.notification.candidate_progress.viewed.title' }),
                description: intl.formatMessage({ id: 'global.notification.candidate_progress.viewed.description' }),
                ...notificationTypesSettings[types_1.NotificationType.COMPANY_VIEWED_RESUME_NOTIFICATION],
            });
        }
        if (types_1.NotificationType.CREDITS_PAID_NOTIFICATION in notificationTypesSettings) {
            typeSettingRows.push({
                typeId: types_1.NotificationType.CREDITS_PAID_NOTIFICATION,
                name: intl.formatMessage({ id: 'global.notification.paid_credits.title' }),
                description: intl.formatMessage({ id: 'global.notification.paid_credits.table_description' }),
                ...notificationTypesSettings[types_1.NotificationType.CREDITS_PAID_NOTIFICATION],
            });
        }
        if (types_1.NotificationType.COMPANY_OFFER_DEADLINE_NOTIFICATION in notificationTypesSettings) {
            typeSettingRows.push({
                typeId: types_1.NotificationType.COMPANY_OFFER_DEADLINE_NOTIFICATION,
                name: intl.formatMessage({ id: 'global.notification.offer_deadline.title' }),
                description: intl.formatMessage({ id: 'global.notification.offer_deadline.description' }),
                ...notificationTypesSettings[types_1.NotificationType.COMPANY_OFFER_DEADLINE_NOTIFICATION],
            });
        }
        return typeSettingRows;
    }, [notificationTypesSettings, appContext.language]);
    const columns = react_1.default.useMemo(() => [
        {
            dataIndex: 'name',
            title: intl.formatMessage({ id: 'global.notification.type' }),
            width: 120,
        },
        {
            dataIndex: 'description',
            title: intl.formatMessage({ id: 'global.notification.description' }),
        },
        {
            dataIndex: 'is_enabled',
            title: ((0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)("div", { children: intl.formatMessage({ id: 'global.notification.web_notifications' }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(icons_1.BellOutlined, {}) })] })),
            align: 'center',
            render: (isEnabled, { typeId }) => ((0, jsx_runtime_1.jsx)(elements_1.Checkbox, { checked: isEnabled, onChange: (e) => onCheckboxChange(e.target.checked, 'is_enabled', typeId) })),
            width: 120,
        },
        {
            dataIndex: 'should_send_email',
            title: ((0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)("div", { children: intl.formatMessage({ id: 'global.notification.email_notifications' }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(icons_1.MailOutlined, {}) })] })),
            align: 'center',
            render: (shouldSendEmail, { typeId }) => ((0, jsx_runtime_1.jsx)(elements_1.Checkbox, { checked: shouldSendEmail, onChange: (e) => onCheckboxChange(e.target.checked, 'should_send_email', typeId) })),
            width: 120,
        },
    ], [notificationTypesSettings, appContext.language]);
    return ((0, jsx_runtime_1.jsx)(elements_1.Table, { bordered: true, pagination: false, scroll: { x: 660 }, dataSource: rows, columns: columns, rowKey: "typeId", className: "m-t-m", loading: isLoading }));
}
